<template>
  <div class="login">
    <div class="content" v-loading="guestCheckoutLoading">
      <p class="top-titles">{{ $t('new_customer') }}</p>
      <div class="guest-head">
        <p class="guest-txt bold">{{ $t('save_time_now') }}</p>
        <p class="guest-txt">{{ $t('option_to_register') }}</p>
        <p class="guest-txt">{{ $t('create_a_account') }}</p>
      </div>
      <div class="input_box input_box_top">
        <span style="margin-left: 20px">{{ $t("email") }}</span>
        <el-input
          :class="[this.guestCheckoutErrors.username ? 'el-input-error' : 'el-input']"
          v-model="guestCheckoutForm.username"
          :placeholder="[this.guestCheckoutErrors.username ? this.guestCheckoutErrors.username : $t('enter_email_address')]"
        ></el-input>
        <p class="input_error_msg">{{this.guestCheckoutErrors.username}}</p>
      </div>
      <div class="input_box input_box_top">
        <span style="margin-left: 30px">{{ $t("phoneOptional") }}</span>
        <el-input
          :class="[this.guestCheckoutErrors.phone ? 'el-input-error' : 'el-input']"
          v-model="guestCheckoutForm.phone"
          :placeholder="[this.guestCheckoutErrors.phone ? this.guestCheckoutErrors.phone : $t('enter_phone')]"
        >
          <template slot="append">
            <div @click.stop="getPhoneActiveCodeByPhone" :style="isShowSendCodeTime ? 'opacity: 0.6' : ''">
              {{ $t('send_code') }}
              <span v-if="isShowSendCodeTime">({{ sendCodeTime }})</span>
            </div>
          </template>
        </el-input>
        <span class="input_error_msg">{{ this.guestCheckoutErrors.phone }}</span>
      </div>
      <div class="input_box input_box_top">
        <span style="margin-left: 30px">{{ $t("verification_code") }}</span>
        <el-input
          :class="[this.guestCheckoutErrors.code ? 'el-input-error' : 'el-input']"
          v-model="guestCheckoutForm.code"
          :placeholder="[this.guestCheckoutErrors.code ? this.guestCheckoutErrors.code : $t('enter_code')]"
        ></el-input>
        <span class="input_error_msg">{{ this.guestCheckoutErrors.code }}</span>
      </div>
      <div class="button-center">
        <button @click="guestLogIn">{{ $t('guest_checkout') }}</button>
      </div>
      <div class="guest-account">
        <p>
        <span @click="toggleLogIn">{{$t('login')}}</span> or <span @click="toggleRegister">{{ $t("register") }}</span>
        </p>
    </div>
    </div>
    <div class="close-modal">
      <img
        @click="toggleGuestCheckoutVisiblity(false)"
        src="../assets/img/closemodal.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { isUserAuthenticated } from "../store/modules/cart";
const defaultCodeTime = 60

export default {
  name: "guestCheckout",
  data() {
    return {
      guestCheckoutForm: {
        username: '',
        password: '',
        phone: "",
        // 用户收到的短信验证码
        code: "",
        // 调获取短信验证码接口返回的token
        token: "",
      },
      guestCheckoutErrors: {
        username: '',
        phone: "",
        code: ""
      },
      guestCheckoutLoading: false,
      guestCheckoutSuccess: false,
      sendCodeTime: 0,
      timeoutId: ''
    }
  },
  methods: {
    ...mapMutations('orders', ['toggleOrderModal']),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility', 'toggleGuestCheckoutVisiblity', 'toggleWarehouseSelectionModalVisibility']),
    ...mapActions('auth', ['checkUsernameReturn', 'guestCheckout', 'LoginRequest', 'getPhoneActiveCode']),
    async guestLogIn() {
      await this.checkForm(this.guestCheckoutForm)
      if (this.guestCheckoutErrors.username || this.guestCheckoutErrors.phone || this.guestCheckoutErrors.code) {
        return
      }
      this.guestCheckoutLoading = true;
      // 账号不存在
      let data = {
        email: this.guestCheckoutForm.username,
        username: this.guestCheckoutForm.username,
        phone: this.guestCheckoutForm.phone,
        token: this.guestCheckoutForm.token,
        code: this.guestCheckoutForm.code
      }
      this.guestCheckout(data)
        .then((res) => {
          this.guestCheckoutLoading = false;
          this.LoginRequest({username: this.guestCheckoutForm.username, password: res.data });
        })
        .catch((err) => {
          this.guestCheckoutLoading = false;
          const errData = err.response.data
          console.log(errData);
          this.guestCheckoutErrors.code = this.$t('codeIncorrect')
        });
    },
    resetForm() {
      Object.keys(this.guestCheckoutForm).forEach(key => {
        this.guestCheckoutForm[key] = ''
      })
    },
    exitGuestCheckout() {
      this.toggleGuestCheckoutVisiblity(false);
      this.toggleRegisterModalVisibility(false);
      this.toggleLoginModalVisibility(true);
    },
    toggleLogIn() {
      this.toggleGuestCheckoutVisiblity(false);
      this.toggleRegisterModalVisibility(false);
      this.toggleLoginModalVisibility(true);
    },
    toggleRegister() {
      this.toggleGuestCheckoutVisiblity(false);
      this.toggleLoginModalVisibility(false);
      this.toggleRegisterModalVisibility(true);
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhoneNumber: function (phone) {
      // const phoneNumberRegEx = /^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-/\s.]?[0-9]{4}$/;
      const phoneNumberRegEx = /^\d{10}$/;
      return phoneNumberRegEx.test(phone);
    },
    async checkForm(form) {
      this.resetErrors()
      if (!this.validEmail(form.username)) {
        this.guestCheckoutErrors.username = this.$t("emailValidRequired");
      } else {
        const isEmailTaken = await this.checkUsernameReturn({ username: this.guestCheckoutForm.username })
          .then(response => response.data.isTaken)
          .catch(() => true)
        // 邮箱已存在
        if (isEmailTaken) {
          this.guestCheckoutErrors.username = this.$t('guest_order_email_tip_reset')
        }
      }
      if (!this.validPhoneNumber(form.phone)) {
        this.guestCheckoutErrors.phone = this.$t("phoneValidRequired");
      } else {
        const isPhoneTaken = await this.checkUsernameReturn({ username: this.guestCheckoutForm.phone })
          .then(response => response.data.isTaken)
          .catch(() => true)
        // 电话已存在
        if (isPhoneTaken) {
          this.guestCheckoutLoading = false;
          return this.guestCheckoutErrors.phone = this.$t('guest_order_phone_tip_reset')
        }
      }
      if (!form.code) {
        this.guestCheckoutErrors.code = this.$t('codeRequired')
      }
    },
    resetErrors() {
      Object.keys(this.guestCheckoutErrors).forEach(key => {
        this.guestCheckoutErrors[key] = ''
      })
    },
    async getPhoneActiveCodeByPhone() {
      if (this.isShowSendCodeTime) return
      this.guestCheckoutErrors.phone = ''
      const phone = this.guestCheckoutForm.phone
      if (!this.validPhoneNumber(phone)) {
        return this.guestCheckoutErrors.phone = this.$t("phoneValidRequired");
      }
      const {type, data} = await this.getPhoneActiveCode(phone)
      switch (type) {
        case 0:
          this.guestCheckoutForm.token = data
          this.sendCodeTimeChangeAfter()
          break
        case 1:
          this.guestCheckoutErrors.phone = this.$t("guest_order_phone_tip_reset")
          break
        case 2:
          this.guestCheckoutErrors.phone = this.$t("tryAgain")
          break
      }
    },
    sendCodeTimeChange() {
      this.sendCodeTime--
      if (this.sendCodeTime <= 0) {
        return
      }
      this.timeoutId = setTimeout(this.sendCodeTimeChange, 1000)
    },
    sendCodeTimeChangeAfter() {
      clearTimeout(this.timeoutId)
      this.sendCodeTime = defaultCodeTime
      this.sendCodeTimeChange()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      console.log("91203791873")
      this.$store.dispatch("cart/getCart");
      this.$store.dispatch("auth/fetchCustomerInformation");
    } else {
      // this.$store.dispatch("cart/fetchCartProducts");
      // this.$store.dispatch("auth/fetchCustomerInformation");
    }
    next();
  },
  computed: {
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
      userDetails: state => state.auth.userDetails,
      guestCheckoutModalVisiblity: state => state.navbar.guestCheckoutModalVisiblity,
      cartProductsList: state => state.cart.cartProductsList
    }),
    isShowSendCodeTime() {
      return this.sendCodeTime > 0
    }
  },
  watch: {
    loggedIn: function(newVal, oldVal) {
      if (newVal === true) {
        this.toggleGuestCheckoutVisiblity(false);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/guestCheckoutModal.less";
</style>



// WEBPACK FOOTER //
// src/view/guestCheckout.vue